import styled from 'styled-components';

import { ChatAreaContainer } from '../../styled-components/ChatAreaContainer';

export const TranscriptWrapper = styled(ChatAreaContainer)`
  overflow-y: auto;
  overflow-x: hidden;
  height: 100%;
  display: flex;
  flex-direction: column;
`;
